var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"bg-row"},[_c('td',{on:{"click":function($event){return _vm.$emit('toggle', _vm.item)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.isRowExpanded ? "mdi-minus" : "mdi-plus"))])],1),_c('td'),_c('td',{staticClass:"client-name",attrs:{"colspan":"10"}},[_vm._v(_vm._s(_vm.item.client_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }